import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ThemeResolver } from './theme/theme.resolver';

const routes: Routes = [
  { path: '', redirectTo: '/sessions/list', pathMatch: 'full', resolve: { theme: ThemeResolver } },
  { path: '**', redirectTo: '/error', resolve: { theme: ThemeResolver } }
];

export const router: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./src/app/app.routes.ts